<script>
import { authApi } from 'api'
export default {
  render (h) {
    return h()
  },
  beforeCreate () {
    if (!this.$route.query.SAMLResponse) {
      authApi.logoutUrl()
        .then(redirect => { window.location = redirect })
        .catch(() => { window.location = process.env.APP_BASE + '/noaccess' }) // Var ikke logget inn
    } else {
      // Valider i api og logg ut
      authApi.validateLogoutSamlResponse(this.$route.query.SAMLResponse)
        .then(() => {
          var bookId = this.$store.getters.currentUser.book_id
          this.$store.commit('deleteToken')
          this.$router.push({ name: 'LoggedOut', query: { i: bookId } })
        })
        .catch(response => { window.location = process.env.APP_BASE + (response.status < 500 ? '/noaccess' : '/logout') })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/auth/Logout.vue